<app-navbar [data]="securityService.startStoreInfo"></app-navbar>

<div class="body-wrapper">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 bg-info" *ngIf="this.securityService.startStoreInfo !== undefined">
                <h2 class="text-white p-2">{{this.securityService?.startStoreInfo?.store?.name}} 
                    <span *ngIf="!this.securityService?.startStoreInfo?.ecommerceThresholdStatus.doesMeetMinimumNumberOfOnlineMspcs" class="text-white bg-danger p-1 mx-auto">You have not met the requirements for selling on Ecommerce</span>
                    <span *ngIf="this.securityService?.startStoreInfo?.ecommerceThresholdStatus.doesMeetMinimumNumberOfOnlineMspcs" class="text-success p-1">You have met the requirements for selling on Ecommerce</span>
                </h2>
                <small class="text-white">Store Open Date: {{this.securityService?.startStoreInfo?.store?.displayStoreOpenDate}}</small>
                <small *ngIf="!this.securityService?.startStoreInfo?.store?.isActiveOnEcommerce" style="display:block; font-weight: bold;" class="text-white bg-danger p-1">You are not currently enabled for ecommerce</small>
                <small *ngIf="this.securityService?.startStoreInfo?.store?.isActiveOnEcommerce" style="display:block; font-weight: bold;" class="text-white bg-success p-1">You are currently enabled for ecommerce</small>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-12">
                <alert></alert>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
<footer class="footer bg-dark text-white">
    <div class="container-fluid d-none d-sm-block">
        <div class="py-1 pd-0 md-0 text-center">
            <nav class="navbar navbar-expand px-0">
                <ul class="nav navbar-nav">
                    <li class="nav-item">Copyright &copy; 2020 MSKS IP Inc.</li>
                </ul>
            </nav>
        </div>
    </div>
    <div class="container-fluid d-block d-sm-none">
        <p class="text-size-12 text-center pt-4">Copyright &copy; 2020 MSKS IP Inc.</p>
    </div>
</footer>
